module.exports = __webpack_public_path__ + "img/2017-05-04.97f09250.jpg";